export const GET_DOCUMENT_REQUESTS = "GET_DOCUMENT_REQUESTS"
export const GET_DOCUMENT_REQUESTS_FAIL = "GET_DOCUMENT_REQUESTS_FAIL"
export const GET_DOCUMENT_REQUESTS_SUCCESS = "GET_DOCUMENT_REQUESTS_SUCCESS"

export const ADD_NEW_DOCUMENT_REQUEST = "ADD_NEW_DOCUMENT_REQUEST"
export const ADD_DOCUMENT_REQUEST_SUCCESS = "ADD_DOCUMENT_REQUEST_SUCCESS"
export const ADD_DOCUMENT_REQUEST_FAIL = "ADD_DOCUMENT_REQUEST_FAIL"

export const UPDATE_DOCUMENT_REQUEST = "UPDATE_DOCUMENT_REQUEST"
export const UPDATE_DOCUMENT_REQUEST_SUCCESS = "UPDATE_DOCUMENT_REQUEST_SUCCESS"
export const UPDATE_DOCUMENT_REQUEST_FAIL = "UPDATE_DOCUMENT_REQUEST_FAIL"

export const DELETE_DOCUMENT_REQUEST = "DELETE_DOCUMENT_REQUEST"
export const DELETE_DOCUMENT_REQUEST_SUCCESS = "DELETE_DOCUMENT_REQUEST_SUCCESS"
export const DELETE_DOCUMENT_REQUEST_FAIL = "DELETE_DOCUMENT_REQUEST_FAIL"





